import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  DialogActions,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';
import HeaderWithActions from '../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../lib/designSystem/Table';
import {
  createFactoringResellPendingAccounts,
  getFactoringResellsArrear,
} from '../../../../../../../lib/api/funds';
import { showAlert } from '../../../../../../../lib/functions/utils';

const CreateArrearFundPendingAccounts = (props: any) => {
  const { open, setOpen, factoringResellsIds, date } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [openConfirmCreateArrear, setOpenConfirmCreateArrear] = useState(false);
  const [pendingAccounts, setPendingAccounts] = useState<any[]>([]);
  const handleSubmit = async () => {
    try {
      await createFactoringResellPendingAccounts(dispatch, {
        pendingAccounts,
      });
      setOpenConfirmCreateArrear(false);
      setOpen(false);
      showAlert(
        dispatch,
        'success',
        'Cuentas por cobrar generadas correctamente',
      );
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al generar las cuentas por cobrar');
    }
  };

  const handleChangeArrearToAdd = (event: any) => {
    const amount = event.target.value.split('.').join('').split('$').join('');
    const payment = pendingAccounts.find(
      (payment: any) => String(payment.id) === event.target.name,
    );

    payment.amount = Number(amount);
    setPendingAccounts([...pendingAccounts]);
  };

  const setUpPossiblePendingAccounts = async () => {
    try {
      const response = await getFactoringResellsArrear(dispatch, {
        factoringResellsIds,
        date,
      });
      const responseWithAmount = response
        .map((item: any) => ({
          ...item,
          amount: item.arrearAmount,
        }))
        .filter((item: any) => item.amount > 0);
      if (responseWithAmount.length === 0) {
        setOpen(false);
        return;
      }
      setPendingAccounts(responseWithAmount);
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al obtener las cuentas por cobrar');
    }
  };

  const setUp = async () => {
    setLoading(true);
    await setUpPossiblePendingAccounts();
    setLoading(false);
  };

  useEffect(() => {
    setUp();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <Dialog maxWidth="xl" fullWidth open={open}>
      <div style={{ padding: 20, minHeight: 200 }}>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <div>
            <HeaderWithActions title="Generar cuentas por cobrar" />
            <Typography variant="body1" paddingBottom={2}>
              Algunas facturas ya pasaron de la fecha de pago, te ayudamos a
              calcular la tasa de mora según la información que dejaste al
              inicio de la ventas. Puedes modifcarla si hubo algun cambio con el
              fondo.
            </Typography>
            <Typography variant="body1">
              Al presionar confirmar, se crearán las cuentas por cobrar con el
              motivo de mora de fondos. Si no quieres crearlas, puedes salir de
              la ventana y luego crearlas manualmente.
            </Typography>
            <div style={{ padding: '10px 0px' }}>
              <EnhancedTable
                data={pendingAccounts}
                dataHeaders={[
                  {
                    key: 'id',
                    label: 'Id Venta',
                    type: 'numeric-id',
                  },
                  {
                    key: 'folio',
                    label: 'Folio Doc',
                  },
                  {
                    key: 'businessName',
                    label: 'Cliente',
                  },
                  {
                    key: 'stakeholderName',
                    label: 'Deudor',
                  },
                  {
                    key: 'documentAmount',
                    label: 'Monto Documento',
                    type: 'money',
                  },
                  {
                    key: 'fundName',
                    label: 'Fondo',
                  },
                  {
                    key: 'dueDate',
                    label: 'Fecha de vencimiento',
                    type: 'date',
                  },
                  {
                    key: 'amount',
                    label: 'Mora a registrar',
                    type: 'money',
                    handleChange: handleChangeArrearToAdd,
                  },
                ]}
              />
            </div>
            <DialogActions>
              <CustomButton onClick={() => setOpen(false)} color="secondary">
                Salir
              </CustomButton>
              <CustomButton
                onClick={() => setOpenConfirmCreateArrear(true)}
                color="primary"
              >
                Generar CPP
              </CustomButton>
            </DialogActions>
          </div>
        )}
      </div>
      <Dialog
        open={openConfirmCreateArrear}
        onClose={() => setOpenConfirmCreateArrear(false)}
      >
        <DialogTitle>
          <Typography variant="h6">Confirmar cuentas por cobrar</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Estás seguro de querer generar las cuentas por cobrar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={() => setOpenConfirmCreateArrear(false)}
            color="secondary"
          >
            Cancelar
          </CustomButton>
          <CustomButton onClick={() => handleSubmit()} color="primary">
            Confirmar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default CreateArrearFundPendingAccounts;
